var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("span", {
        staticClass: "document-issue-mark",
        style: {
          backgroundColor: _vm.color,
        },
        attrs: { id: `document-issue-mark-${_vm._uid}` },
      }),
      _c(
        "b-popover",
        {
          attrs: {
            triggers: "hover",
            placement: "top",
            target: `document-issue-mark-${_vm._uid}`,
          },
        },
        [_vm._v(" " + _vm._s(_vm.label) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }